// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const UserRemoveIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "UserRemove/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM14 17a6 6 0 0 0-12 0h12ZM13 8a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
}));
export default UserRemoveIcon;